import styled from 'styled-components';

const Wrapper = styled.div`
  font-size: 2.5rem;
  flex-direction: column;
  text-align: center;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const TitleWrapper = styled.div`
  font-family: 'Black Han Sans', Courier, monospace;
`;

const EmojiWrapper = styled.div`
  font-size: 8rem;
  margin-bottom: 5rem;
`;

const ErrorPage = ({ msg, title = 'ERROR', emoji = '😥' }) => {

  return (
    <Wrapper>
      <EmojiWrapper>{emoji}</EmojiWrapper>
      <TitleWrapper> {title}</TitleWrapper>
      {msg || '404 Not Found'}
    </Wrapper>
  );
};

export default ErrorPage;
